export const isLeftArrowVisible = (
  wrapperRef: React.RefObject<HTMLDivElement>
) => {
  if (wrapperRef.current) {
    const wrapperEl = wrapperRef.current
    return wrapperEl.scrollLeft > 0
  }
  return false
}

export const isRightArrowVisible = (
  wrapperRef: React.RefObject<HTMLDivElement>
) => {
  if (wrapperRef.current) {
    const wrapperEl = wrapperRef.current
    return (
      wrapperEl.scrollWidth > wrapperEl.clientWidth &&
      wrapperEl.scrollLeft < wrapperEl.scrollWidth - wrapperEl.clientWidth
    )
  }
  return false
}

interface HandleScrollClickProps {
  direction: 'left' | 'right'
  wrapperRef: React.RefObject<HTMLDivElement>
  setIsLeftArrowVisible: (isVisible: boolean) => void
  setIsRightArrowVisible: (isVisible: boolean) => void
}

export const handleScrollClick = ({
  direction,
  wrapperRef,
  setIsLeftArrowVisible,
  setIsRightArrowVisible,
}: HandleScrollClickProps) => {
  if (wrapperRef.current) {
    const wrapperEl = wrapperRef.current
    const { scrollWidth, clientWidth, scrollLeft } = wrapperEl

    if (direction === 'left') {
      wrapperEl.scrollTo({
        left: Math.max(scrollLeft - clientWidth, 0),
        behavior: 'smooth',
      })
    } else {
      wrapperEl.scrollTo({
        left: Math.min(scrollLeft + clientWidth, scrollWidth - clientWidth),
        behavior: 'smooth',
      })
    }

    setIsLeftArrowVisible(isLeftArrowVisible(wrapperRef))
    setIsRightArrowVisible(isRightArrowVisible(wrapperRef))
  }
}
